import { Action, configureStore, Store } from '@reduxjs/toolkit';
import { injectDispatch, injectGetToken } from '~/libs/api';
import { combineReducers } from 'redux';
import processingPersonal from '~/store/processing-personal/slices.ts';
import identification from './identification-form/slices.ts';
import iit from './iit/slices.ts';
import diia from './diia/slices.ts';
import otpVerification from '~/store/otp-verification/slices.ts';
import remoteBankingContacts from '~/store/remote-banking-contacts/slices.ts';
import users from '~/store/users/slices.ts';
import covenants from '~/store/covenants/slice.ts';
import guarantees from '~/store/guarantees/slice.ts';
import tasks from '~/store/tasks/slice.ts';

const isProd = import.meta.env.MODE === 'production';

const serializableCheck = {
  ignoredActions: [
    'SET_KEY_CONTAINER',
    'covenantsPage/exportSupervisorApplications/fulfilled',
    'covenantsPage/downloadSupervisorApplicationDocument/fulfilled',
    'covenantsPage/downloadApplicationDocument/fulfilled',
    'covenantsPage/generateFinancialConditionCertificate/fulfilled',
  ],
  ignoredPaths: ['cipher.privateKeyReducer.keyContainer'],
};

const store = configureStore({
  reducer: combineReducers({
    users,
    identification,
    iit,
    diia,
    processingPersonal,
    otpVerification,
    remoteBankingContacts,
    covenants,
    guarantees,
    tasks,
  }),
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck,
      ...(isProd && { immutableCheck: { warnAfter: 100 } }),
    });
  },
});

injectDispatch(store.dispatch);
injectGetToken(() => store.getState().users.token);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store as Store<RootState, Action>;
